(() => {
  if (window.daylaCollectionCardPreviewReady) return;
  window.daylaCollectionCardPreviewReady = true;

  const cardSelector = '[data-dayla-collection-card]';
  const triggerSelector = '[data-dayla-collection-variant]';
  const variantListSelector = '.dayla-collection-card__variants';

  const getCard = (element) => element?.closest(cardSelector);

  const setImage = (card, trigger) => {
    const image = card?.querySelector('[data-dayla-collection-primary-image]');
    if (!image || !trigger?.dataset.daylaImage) return;

    image.src = trigger.dataset.daylaImage;
    if (trigger.dataset.daylaSrcset) image.srcset = trigger.dataset.daylaSrcset;
    card.classList.add('dayla-collection-card--variant-active');
  };

  const resetImage = (card) => {
    const image = card?.querySelector('[data-dayla-collection-primary-image]');
    if (!image) return;

    const selectedTrigger = card.querySelector(`${triggerSelector}[aria-pressed="true"]`);
    if (selectedTrigger) {
      setImage(card, selectedTrigger);
      return;
    }

    if (image.dataset.daylaDefaultSrc) image.src = image.dataset.daylaDefaultSrc;
    if (image.dataset.daylaDefaultSrcset) image.srcset = image.dataset.daylaDefaultSrcset;
    card.classList.remove('dayla-collection-card--variant-active');
  };

  const selectTrigger = (card, trigger) => {
    card.querySelectorAll(triggerSelector).forEach((item) => {
      const selected = item === trigger;
      item.classList.toggle('dayla-collection-card__variant--selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    setImage(card, trigger);
  };

  document.addEventListener('mouseover', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger || trigger.contains(event.relatedTarget)) return;
    setImage(getCard(trigger), trigger);
  });

  document.addEventListener('focusin', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (trigger) setImage(getCard(trigger), trigger);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;
    selectTrigger(getCard(trigger), trigger);
  });

  document.addEventListener('mouseout', (event) => {
    const variantList = event.target.closest(variantListSelector);
    if (!variantList || variantList.contains(event.relatedTarget)) return;
    resetImage(getCard(variantList));
  });

  document.addEventListener('focusout', (event) => {
    const variantList = event.target.closest(variantListSelector);
    if (!variantList) return;

    window.setTimeout(() => {
      if (!variantList.contains(document.activeElement)) resetImage(getCard(variantList));
    }, 0);
  });

  document.addEventListener('mouseout', (event) => {
    const card = event.target.closest(cardSelector);
    if (!card || card.contains(event.relatedTarget)) return;
    resetImage(card);
  });
})();
